import React, {useState} from 'react';
import 'moment-timezone';
import Moment from 'react-moment';
import Page from "../../components/Page/Page";
import Status from "../../components/Status/Status";
import Controls from "../../components/Controls/Controls";
import { useQuery } from "@apollo/client";
import { FETCH_REQUEST } from "../../grapgql/gql";
import { Table, Td, Tr } from "../../components/UI/Table/Table";
import {useSearch} from "../../context/search";
import Search from "../../components/Search/Search";
import Modal from "../../components/Modal/Modal";


const Request = () => {
    const { searchValue } = useSearch();
    const [page, setPage] = useState(1);

    const { loading, data: { getScRequests: request } = {}, fetchMore } = useQuery(FETCH_REQUEST, {
        pollInterval: 2000,
        variables: {
            page: page,
            limit: 20,
            search: searchValue
        }
    });

    return (
        <Page
            title="Активные заявки"
            callback={setPage}
            fetchMore={fetchMore}
            loading={loading}
            paginator={!loading && request.paginator}
            controls={
                <>
                    <Search
                        setPage={setPage}
                        placeholder="Поиск: код, компания, email, номер телефона, серийник, модель"
                    />
                </>
            }
        >
            <Modal />
            <Table value={[
                {name: "number", label: '№'},
                {name: "company", label: 'Компания', type: 'company'},
                {name: "device", label: 'Приборы', type: 'device' },
                {name: "createdAt", label: 'Дата регистрации'},
                {name: "phone", label: 'Номер телефона'},
                {name: "status", label: 'Статус заявки', type: 'controls'},
                {name: "controls", label: 'Действия'}
            ]}>
                { request && request.data.map((item, index) => {
                    return (
                        <Tr key={item.id}>
                            <Td>{item.code}</Td>
                            <Td>{item.companyname} </Td>
                            <Td>
                                {item.devices.map((item, index) => {
                                    return (
                                        <p key={index}>
                                            {item.model} ({item.serial})
                                        </p>
                                    )
                                })}
                            </Td>
                            <Td><Moment date={item.createdAt} format="DD.MM.YYYY, HH:mm"/></Td>
                            <Td>{item.userphone}</Td>
                            <Td style={{ width: "200px"}}>
                                <Status defaultStatus={item.status.label} id={item.id} />
                            </Td>
                            <Td style={{textAlign: 'center', width: "125px"}} >
                                <Controls
                                    item={item}
                                    link="/request/"
                                    controls={{
                                        delete: true,
                                        pdf: true,
                                        info: true
                                    }}
                                />
                            </Td>
                        </Tr>
                    )
                }) }
            </Table>
        </Page>
    )
};

export default Request;


